module.exports = __webpack_public_path__ + "images/emoji/bamboo.db1c7ee60dd902ef2a1e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bamboo.png
// module id = hvrB
// module chunks = 1